<template>
  <h3 class="x5-modal-error">⚠️ There was a problem loading this modal content.</h3>
</template>

<script>
export default {
  name: 'x5-modal-error'
}
</script>
